import { Project, ProjectAPI } from "@brg/api";

/**
 * Это похоже на какое-то двинутое временное решение? Ну, собственно да, оно таким и является:)
 */
export const BAYER_ID = "d544e46b75774d48b3654bdc2f209998";
export const DDD_ID = "104b268d94d74dd7b71c818e34b6ae1a";

export const NOMINATIONS_STATUSES = [0,1,4,3,5,6];

export enum STATUSES {
    'Draft' = 0,
    'Open' = 1,
    'Announcement' = 2,
    'Voting' = 3,
    'Summarizing' = 4,
    'Completed' = 5,
    'Archived' = 6,
    'Deleted' = 7,
}

export enum STATUSES_NEW {
  'Open' = 1,
  'Completed' = 5,
}

export const STATUSES_List: {
    label: string;
    value: number;
  }[] = Object.entries(STATUSES)
    .map(([label, value]) => ({ label: label, value: value as number }))
    .filter(x => !isNaN(x.value));

export enum COMPETITION_TYPE {
  'WithoutQuestionnaire' = 0,
  'WithQuestionnaire' = 1,
  'WithNominations' = 3,
  'PreRegistration' = 4,
  'Automatic' = 5,
  'Rating' = 6,
  'RatingArt' = 7,
  'Special' = 8,
  'LmsExam' = 9,
  'RatingsFashion' = 10,
  'RatingsEducation' = 11,
  'RatingsStartups' = 12,
  'RatingsPlus' = 13,
  'Practices' = 14,
  //aki = 2
}

export const RATING_COMPETITION_TYPES: COMPETITION_TYPE[] = [
  COMPETITION_TYPE.Rating,
  COMPETITION_TYPE.RatingArt,
  COMPETITION_TYPE.RatingsFashion,
  COMPETITION_TYPE.RatingsEducation,
  COMPETITION_TYPE.RatingsStartups,
  COMPETITION_TYPE.RatingsPlus,
];

export const isRatingCompetitionType = (type?: number): boolean => {
  if (type === undefined || type === null) {
    return false;
  }

  return RATING_COMPETITION_TYPES.includes(type as COMPETITION_TYPE);
};

export const NEW_DAFES_CHOICE_COMPETITION_TYPES: COMPETITION_TYPE[] = [
  COMPETITION_TYPE.RatingsFashion,
  COMPETITION_TYPE.RatingsEducation,
  COMPETITION_TYPE.RatingsStartups,
  COMPETITION_TYPE.RatingsPlus,
];

export const isNewDafesChoiceCompetitionType = (type?: number): boolean => {
  if (type === undefined || type === null) {
    return false;
  }

  return NEW_DAFES_CHOICE_COMPETITION_TYPES.includes(type as COMPETITION_TYPE);
};

export const normalizedCompetitionStatuses = (): Record<string, number> =>
  Object.entries(STATUSES)
    .filter(([, value]) => typeof value === 'number')
    .reduce<Record<string, number>>((acc, [key, value]) => {
      acc[key.toLowerCase()] = value as number;
      return acc;
    }, {});

export const RATING_PROJECT_TYPE_TO_COMPETITION_TYPE: Record<number, COMPETITION_TYPE> = {
  0: COMPETITION_TYPE.Rating,
  1: COMPETITION_TYPE.RatingArt,
  2: COMPETITION_TYPE.RatingsFashion,
  3: COMPETITION_TYPE.RatingsEducation,
  4: COMPETITION_TYPE.RatingsStartups,
  5: COMPETITION_TYPE.RatingsPlus,
};
export const TEAM_FORM_CONTINUE_COMPETITION_QUERY = 'continueCompetition';
export const TEAM_FORM_DEFER_APPLY_PROJECT_QUERY = 'deferApplyProject';
export const QUERY_LEGAL_CONTEST_PROJECT_THEN_FORM = 'legalContestProjectThenForm';
export const QUERY_RESUME_LEGAL_CONTEST_AFTER_FORM = 'resumeLegalContestAfterForm';

export const PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID = '61557662888148bf807a481e0017c11b';

export const COMPETITION_TYPE_List: {
  label: string;
  value: number;
}[] = Object.entries(COMPETITION_TYPE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

export type WinnerT = { project: Project, position: number }

export type NominationWinners = {
  id: string;
  color?: string;
  name: string;
  projects: WinnerT[];
}
import { Project, ProjectAPI } from "@brg/api";

/**
 * Это похоже на какое-то двинутое временное решение? Ну, собственно да, оно таким и является:)
 */
export const BAYER_ID = "d544e46b75774d48b3654bdc2f209998";
export const DDD_ID = "104b268d94d74dd7b71c818e34b6ae1a";

export const NOMINATIONS_STATUSES = [0,1,4,3,5,6];

export enum STATUSES {
    'Draft' = 0,
    'Open' = 1,
    'Announcement' = 2,
    'Voting' = 3,
    'Summarizing' = 4,
    'Completed' = 5,
    'Archived' = 6,
    'Deleted' = 7,
}

export enum STATUSES_NEW {
  'Open' = 1,
  'Completed' = 5,
}

export const STATUSES_List: {
    label: string;
    value: number;
  }[] = Object.entries(STATUSES)
    .map(([label, value]) => ({ label: label, value: value as number }))
    .filter(x => !isNaN(x.value));

export enum COMPETITION_TYPE {
  'WithoutQuestionnaire' = 0,
  'WithQuestionnaire' = 1,
  'WithNominations' = 3,
  'PreRegistration' = 4,
  'Automatic' = 5,
  'Rating' = 6,
  'RatingArt' = 7,
  'Special' = 8,
  'LmsExam' = 9,
  'RatingsFashion' = 10,
  'RatingsEducation' = 11,
  'RatingsStartups' = 12,
  'RatingsPlus' = 13,
  'Practices' = 14,
  //aki = 2
}

export const RATING_COMPETITION_TYPES: COMPETITION_TYPE[] = [
  COMPETITION_TYPE.Rating,
  COMPETITION_TYPE.RatingArt,
  COMPETITION_TYPE.RatingsFashion,
  COMPETITION_TYPE.RatingsEducation,
  COMPETITION_TYPE.RatingsStartups,
  COMPETITION_TYPE.RatingsPlus,
];

export const isRatingCompetitionType = (type?: number): boolean => {
  if (type === undefined || type === null) {
    return false;
  }

  return RATING_COMPETITION_TYPES.includes(type as COMPETITION_TYPE);
};

export const NEW_DAFES_CHOICE_COMPETITION_TYPES: COMPETITION_TYPE[] = [
  COMPETITION_TYPE.RatingsFashion,
  COMPETITION_TYPE.RatingsEducation,
  COMPETITION_TYPE.RatingsStartups,
  COMPETITION_TYPE.RatingsPlus,
];

export const isNewDafesChoiceCompetitionType = (type?: number): boolean => {
  if (type === undefined || type === null) {
    return false;
  }

  return NEW_DAFES_CHOICE_COMPETITION_TYPES.includes(type as COMPETITION_TYPE);
};

export const normalizedCompetitionStatuses = (): Record<string, number> =>
  Object.entries(STATUSES)
    .filter(([, value]) => typeof value === 'number')
    .reduce<Record<string, number>>((acc, [key, value]) => {
      acc[key.toLowerCase()] = value as number;
      return acc;
    }, {});

export const RATING_PROJECT_TYPE_TO_COMPETITION_TYPE: Record<number, COMPETITION_TYPE> = {
  0: COMPETITION_TYPE.Rating,
  1: COMPETITION_TYPE.RatingArt,
  2: COMPETITION_TYPE.RatingsFashion,
  3: COMPETITION_TYPE.RatingsEducation,
  4: COMPETITION_TYPE.RatingsStartups,
  5: COMPETITION_TYPE.RatingsPlus,
};
export const TEAM_FORM_CONTINUE_COMPETITION_QUERY = 'continueCompetition';
export const TEAM_FORM_DEFER_APPLY_PROJECT_QUERY = 'deferApplyProject';
export const QUERY_LEGAL_CONTEST_PROJECT_THEN_FORM = 'legalContestProjectThenForm';
export const QUERY_RESUME_LEGAL_CONTEST_AFTER_FORM = 'resumeLegalContestAfterForm';

export const PAID_WITH_FORM_LEGAL_ENTITIES_FORM_ID = '61557662888148bf807a481e0017c11b';

export const COMPETITION_TYPE_List: {
  label: string;
  value: number;
}[] = Object.entries(COMPETITION_TYPE)
  .map(([label, value]) => ({ label, value: value as number }))
  .filter(x => !isNaN(x.value));

export type WinnerT = { project: Project, position: number }

export type NominationWinners = {
  id: string;
  color?: string;
  name: string;
  projects: WinnerT[];
}
